var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowPasswordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3264 6.21394C17.7214 6.73061 17.7214 7.42811 17.3264 7.94394C16.0822 9.56811 13.0972 12.9123 9.61223 12.9123C6.12723 12.9123 3.14223 9.56811 1.89807 7.94394C1.70589 7.69655 1.60156 7.3922 1.60156 7.07894C1.60156 6.76567 1.70589 6.46133 1.89807 6.21394C3.14223 4.58977 6.12723 1.24561 9.61223 1.24561C13.0972 1.24561 16.0822 4.58977 17.3264 6.21394V6.21394Z",
    stroke: "#407DBB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6123 9.57886C10.993 9.57886 12.1123 8.45957 12.1123 7.07886C12.1123 5.69815 10.993 4.57886 9.6123 4.57886C8.23159 4.57886 7.1123 5.69815 7.1123 7.07886C7.1123 8.45957 8.23159 9.57886 9.6123 9.57886Z",
    stroke: "#407DBB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPasswordIcon);
export default __webpack_public_path__ + "static/media/show_password_icon.7749b94d0717fcfb29c673e58017efe7.svg";
export { ForwardRef as ReactComponent };